import Promise from 'bluebird';
import _, { map, object } from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import pkg from './package.json';

export const { version } = pkg;

export { dummyDataSource } from './demo/mock/dummy-data-source';

export function getAdsGridFactory(initializeGlobalContext = true) {
  if (initializeGlobalContext) {
    return globalContext.define(
      pkg.legacyDependencies,
      () => import(/* webpackMode: 'eager' */ './src/ads-gridview-factory')
    );
  }
  return import(/* webpackMode: 'eager' */ './src/ads-gridview-factory');
}

const adEditorDependencies = [
  'campaignui/feature/crud-ad/view/index',
  'component/config/index',
  'module/app/layout/index',
  'SummaryDataContextManager',
];
let adEditorInitializer = null;

export function getAdEditorInitializer(initializeGlobalContext = true) {
  if (initializeGlobalContext) {
    const adEditorPromise = new Promise((resolve) => {
      if (adEditorInitializer) {
        resolve(adEditorInitializer);
      } else {
        window.require(adEditorDependencies, () => {
          const dependecies = object(
            adEditorDependencies,
            map(adEditorDependencies, dep => window.require(dep))
          );

          globalContext.define(
            adEditorDependencies,
            () => import(/* webpackMode: 'eager' */ './src/ads-editor/initialize-ad-editor')
          )(dependecies).then((result) => {
            adEditorInitializer = result;
            resolve(result);
          });
        });
      }
    });
    return adEditorPromise;
  }
  return import(/* webpackMode: 'eager' */ './src/ads-editor/initialize-ad-editor');
}

let adEditorInitializerWebpack = null;

export function getAdEditorInitializerWebpack(
  initializeGlobalContext = true,
  dependecies
) {
  if (initializeGlobalContext) {
    const adEditorPromise = new Promise((resolve) => {
      if (adEditorInitializerWebpack) {
        resolve(adEditorInitializerWebpack);
      } else {
        globalContext.define(
          adEditorDependencies,
          () => import(/* webpackMode: 'eager' */ './src/ads-editor/initialize-ad-editor')
        )(dependecies).then((result) => {
          adEditorInitializerWebpack = result;
          resolve(result);
        });
      }
    });
    return adEditorPromise;
  }
  return import(/* webpackMode: 'eager' */ './src/ads-editor/initialize-ad-editor');
}

function isSmartShoppingCampaign(permissions, currentCampaign) {
  return permissions.IsSmartShoppingCampaignEnabled && currentCampaign
    && (currentCampaign.CampaignSubType === 12
    || currentCampaign.CampaignSubType === 'ShoppingSmartAds'); // eslint-disable-line
}

export function shouldCallAPIToCreatePA(
  currentCampaign, currentAdGroup, permissions,
  adsCountMap, isNewUI = false
) {
  let shouldCall = false;

  if (currentAdGroup) { // check if ad group level
    if (isSmartShoppingCampaign(permissions, currentCampaign)) { // if smart shopping campaign
      const isResponsiveAdForSSCEnabled = permissions.IsResponsiveAdForSSCEnabled;
      const currentAdsCount = adsCountMap[currentAdGroup.Id];
      const hasResponsiveAd = _.result(currentAdsCount, 'Responsive', false);
      const hasProductAd = _.result(currentAdsCount, 'Product', false);

      if ((isResponsiveAdForSSCEnabled && hasResponsiveAd && !hasProductAd) ||
        (!isResponsiveAdForSSCEnabled && !hasProductAd)) {
        shouldCall = true;
      }
    } else if (currentCampaign.CampaignType === 2
      || (isNewUI && currentCampaign.CampaignType === 'Shopping')) {
      // in newUI, check if CampaignType === 'Shopping'
      shouldCall = true;
    }
  }
  return shouldCall;
}
